import React, {createContext, useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {auth, logInWithEmailPassword, logInWithToken, logout} from "../firebase";

const INITIAL_STATE = {
    currentUser: null,
    redirectUri: null,
    onRedirectCallback: null,
    isLoggedIn: false,
    login: null,
    loginWithEmail: null,
    logout: null
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthProvider = ({ children }) => {

    const [currentUser, setCurrentUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        auth.onAuthStateChanged(function(user) {
            console.log('onAuthStateChanged', user)

            if (user) {
                // User is signed in.
                setCurrentUser(user);
                setIsLoggedIn(true);
            } else {
                // No user is signed in.
                setCurrentUser(null);
                setIsLoggedIn(false);
            }
        });
    }, []);

    const navigate = useNavigate();

    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    const loginCallback = async () => {
        await logInWithToken();
    };

    const loginWithEmail = async (email, password, successHandler, failureHandler) => {
        console.log('email', email)
        console.log('password', password)

        await logInWithEmailPassword(
            email,
            password,
            successHandler,
            failureHandler
        );
    }

    const logoutCallback = async () => {
        await logout();

        await navigate('/');
    };

    return (
        <AuthContext.Provider value={{
            currentUser: currentUser,
            redirectUri: window.location.origin,
            onRedirectCallback: onRedirectCallback,
            isLoggedIn: isLoggedIn,
            login: loginCallback,
            loginWithEmail: loginWithEmail,
            logout: logoutCallback,
        }}>
            {children}
        </AuthContext.Provider>
    );
};
